import { render, staticRenderFns } from "./DSPHFtable.vue?vue&type=template&id=143a83b6&scoped=true&"
import script from "./DSPHFtable.vue?vue&type=script&lang=js&"
export * from "./DSPHFtable.vue?vue&type=script&lang=js&"
import style0 from "./DSPHFtable.vue?vue&type=style&index=0&id=143a83b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a83b6",
  null
  
)

export default component.exports